import React from "react";

/**
 * Skeleton — a soft pulsing placeholder for content that's loading.
 * Warm sand tone (matches TOTO's palette), not the icy grey most apps use.
 */
export function Skeleton({ className = "", ...rest }) {
  return (
    <div
      className={`animate-pulse bg-stone-200/60 rounded-md ${className}`}
      aria-hidden="true"
      {...rest}
    />
  );
}

/** A small vertical stack of skeleton lines — good for Pulse-style metrics. */
export function SkeletonLines({ rows = 4, className = "" }) {
  return (
    <div className={`space-y-3 ${className}`} data-testid="skeleton-lines">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-baseline justify-between py-2 border-b border-stone-50 last:border-b-0">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-4 w-20" />
        </div>
      ))}
    </div>
  );
}

/** A single candidate-card-shaped skeleton for the Hiring Kanban. */
export function SkeletonCard({ className = "" }) {
  return (
    <div className={`bg-white subtle-border rounded-xl p-3 ${className}`} data-testid="skeleton-card">
      <Skeleton className="h-3.5 w-28 mb-2" />
      <Skeleton className="h-2.5 w-16" />
    </div>
  );
}

export default Skeleton;
